'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPower = function TiPower(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.2 31c-2.9 0-5.6-1.2-7.7-3.2-2-2.1-3.2-4.8-3.2-7.7s1.2-5.6 3.2-7.6c0.7-0.7 1.7-0.7 2.4 0s0.6 1.7 0 2.3c-1.5 1.4-2.2 3.3-2.2 5.3s0.7 3.9 2.2 5.3c1.4 1.4 3.3 2.2 5.3 2.2s3.9-0.8 5.3-2.2c1.4-1.4 2.2-3.3 2.2-5.3s-0.8-3.9-2.2-5.3c-0.7-0.6-0.7-1.7 0-2.3s1.7-0.7 2.3 0c2.1 2 3.2 4.7 3.2 7.6s-1.1 5.6-3.2 7.7c-2 2-4.7 3.2-7.6 3.2z m0-12.7c-1 0-1.7-0.7-1.7-1.6v-8.4c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6v8.4c0 0.9-0.7 1.6-1.6 1.6z' })
        )
    );
};

exports.default = TiPower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/power.js
// module id = 3695
// module chunks = 0